import { combineReducers } from "redux";
import authentication from "../Login/Reducer";
import landing from "../Landing/Reducer";

const reducers = combineReducers({
    landing,
    authentication, 
});

export default reducers;